// @ts-check
import { debounce } from "./debounce";
import { getAll } from "./querySelector";

// Support Test
const supportsContainerQueries = "container" in document.documentElement.style;


if ( !supportsContainerQueries ) {

    const cardWatcher = new ResizeObserver( debounce( ( entries ) => {
        entries.forEach( entry => {
            let breakpoint = 200;

            if ( entry.target.classList.contains( 'card--post' ) ) {
                breakpoint = 400;
            } else if ( entry.target.classList.contains( 'card--hut' ) ) {
                breakpoint = 720;
            }

            if ( entry.target.offsetWidth > breakpoint ) {
                entry.target.classList.remove( 'card--small' );
                entry.target.classList.add( 'card--large' );
            } else {
                entry.target.classList.add( 'card--small' );
                entry.target.classList.remove( 'card--large' );
            }
        } );
    }, 400 ) );

    const postCards = getAll( '.card--post' );
    postCards.forEach( card => {
        cardWatcher.observe( card );
    } );

    const hutCards = getAll( '.card--hut' );
    hutCards.forEach( card => {
        cardWatcher.observe( card );
    } );

}